import { StateHandler } from "../util/getStateFun";
import { startLoader, stopLoader } from "../util/loader";
import { NearbyLocations } from "../util/nearbyLocations";
import { checkDomain, getFranchiseDetails } from "../util/share";
import { FindUsAddressBumper } from "./FindUsAddressBumper";
import { REGEX } from "../constants/regex";

export class FindUsModal {

    private static instance: FindUsModal;
    private readonly zipInput: HTMLInputElement | null;
    private readonly submitBtn: HTMLElement | null;
    private readonly step5: HTMLElement | null;
    private readonly happyText: HTMLElement | null;
    private readonly steps: any;
    static getInstance(): FindUsModal {
        if (!FindUsModal.instance) {
            FindUsModal.instance = new FindUsModal();
        }
        return FindUsModal.instance;
    }
    private constructor() {
        // Get elements
        this.zipInput = document.getElementById("dynamic-local-search-modal") as HTMLInputElement;
        this.submitBtn = document.querySelector(".dynamic-find-local-modal .dynamic-step-1 .form-cta .primary-btn");
        this.step5 = document.querySelector(".dynamic-step-5");
        this.steps = {
            step1: document.querySelector(".dynamic-step-1"),
            step2: document.querySelector(".dynamic-step-2"),
            step3: document.querySelector(".dynamic-step-3"),
            step4: document.querySelector(".dynamic-step-4"),
            step5: document.querySelector(".dynamic-step-5"),
        };
        this.happyText = document.querySelector(".dynamic-step-5 .happy-text");

        if (this.submitBtn) {
            this.submitBtn.addEventListener("click", () => this.handleSubmit());
        }
        if (this.zipInput) {
            this.zipInput?.addEventListener("input", this.zipCodeError.bind(this));
        }
        const closeButton = document.getElementById("dynamic-close-local-modal");
        closeButton?.addEventListener("click", () => {
            // Select all dynamic step elements
            const steps = document.querySelectorAll(".dynamic-step-2, .dynamic-step-3, .dynamic-step-4, .dynamic-step-5");
            steps.forEach(step => step.classList.add("hidden")); // Hide all steps

            // Show only dynamic-step-1
            const step1 = document.querySelector(".dynamic-step-1");
            if (step1) {
                const step1Text1 = document.getElementById("dynamic-step1-text1") as HTMLElement;
                const step1Text2 = document.getElementById("dynamic-step1-text2") as HTMLElement;

                // Hide step1-text1
                if (step1Text1) step1Text1.style.display = "block";

                // Show step1-text2
                if (step1Text2) step1Text2.style.display = "none";
                step1.classList.remove("hidden");
                // Clear the zip input field
                if (this.zipInput) {
                    this.zipInput.value = "";
                }
            }
        });
    }

    zipCodeError() {
        if (!this.zipInput) return;
        const isCaDomainCheck = checkDomain() === 'ca' ?
            !REGEX.caSendZip.test(this.zipInput.value.trim()) :
            !REGEX.sendZip.test(this.zipInput.value.trim());
        const fieldError: any = document.querySelector('.dynamic-find-local-modal .error-msg');

        if (this.zipInput?.value !== '' && isCaDomainCheck) {
            fieldError?.classList.remove('hidden')
            !fieldError.innerHTML.trim() && (fieldError.innerHTML = 'Invalid zip code format.')
        } else {
            fieldError?.classList.add('hidden')
        }
    }

    private callNearbyLocations(units: string, franchiseLimit: number, zipCode: string) {
        new NearbyLocations(units, franchiseLimit).searchNearbyLocations(zipCode)
            .then(this.displayNearbyLocations.bind(this))
            .catch(() => this.handleErrorScenario(zipCode));
    }

    private displayNearbyLocations(data: any) {
        if (!data.length) return this.handleErrorScenario(data);

        Object.values(this.steps).forEach(step => (step as HTMLElement)?.classList.add("hidden"));
        // Handle dynamic-step-5 updates
        const firstLocation = data[0];
        if (firstLocation) {
            const step5 = document.querySelector(".dynamic-step-5");
            step5?.classList.remove("hidden");

            const notFoundWrapper = this.steps.step5.querySelector(".loc-not-found-wrapper");
            notFoundWrapper?.classList.remove("hidden");
            // Update ZIP code inside loc-not-found-wrapper
            const notFoundZipSpan =  this.steps.step5.querySelector(".loc-not-found-wrapper p span");
            if (notFoundZipSpan && this.zipInput) {
                notFoundZipSpan.textContent = this.zipInput?.value.trim();
            }
            this.steps.step5.querySelector(".not-found-text")?.classList.remove("hidden");
            this.steps.step5.querySelector(".happy-text")?.classList.add("hidden");

            this.steps.step5.querySelector(".heading-container h3")!.textContent = firstLocation.doingBusinessAs;
            this.steps.step5.querySelector(".view-web-link")!.setAttribute("href", firstLocation.websiteUrl);
            this.steps.step5.querySelector(".phone-num-wrapper")!.setAttribute("href", `tel:${firstLocation.phoneNumber.replace(/\D/g, "")}`);
            this.steps.step5.querySelector(".phone-num-wrapper")!.innerHTML = `
            <svg class="h-6 w-6">
                <use xlink:href="/_assets-global/images/hero-icon-sprite.svg#phone-outline-primary"></use>
            </svg>
            (${firstLocation.phoneNumber.slice(0, 3)}) ${firstLocation.phoneNumber.slice(3, 6)}-${firstLocation.phoneNumber.slice(6)}
       `;
        }
    }

    private handleSubmit() {
        if (!this.zipInput) return;
        const zipCode = this.zipInput?.value.trim();
        if (this.validateForm()) {
            startLoader();
            this.getData(zipCode);
        }
    }
    getData(zipCode: string) {
        getFranchiseDetails(zipCode, false)
            .then(async (response) => {
                const result = response;
                if (response.length === 0) {
                    this.handleNoResults();
                    return;
                }
                if (!this.happyText) { return };
                const steps = document.querySelectorAll(".dynamic-step-1, .dynamic-step-2, .dynamic-step-3, .dynamic-step-4");
                steps?.forEach(step => step.classList.add("hidden")); // Hide all steps
                this.step5?.classList.remove("hidden");
                const zipCodeSpan = document.querySelector(".dynamic-step-5 .happy-text span") as HTMLElement;
                if (zipCodeSpan && this.zipInput) {
                    stopLoader();
                    zipCodeSpan.textContent = this.zipInput.value.trim(); // Replace with actual ZIP code
                }
                const heading = document.querySelector('.dynamic-step-5 .heading-container h3') as HTMLElement;
                const phoneWrapper = document.querySelector('.dynamic-step-5 .phone-num-wrapper') as HTMLAnchorElement;
                const websiteLink = document.querySelector('.dynamic-step-5 .view-web-link') as HTMLAnchorElement;

                // Format phone number for `tel:` link
                const formattedPhone = result[0].phoneNumber.replace(/\D/g, "");
                const phoneFormat: any = result[0].phoneNumber
                    ? `(${result[0].phoneNumber.slice(0, 3)}) ${result[0].phoneNumber.slice(3, 6)}-${result[0].phoneNumber.slice(6)}`
                    : null;
                // Update content if elements exist
                if (heading) heading.textContent = result[0].doingBusinessAs;
                if (phoneWrapper) {
                    phoneWrapper.href = `tel:${formattedPhone}`;
                    phoneWrapper.innerHTML = `
                <svg class="h-6 w-6">
                    <use xlink:href="/_assets-global/images/hero-icon-sprite.svg#phone-outline-primary"></use>
                </svg>
                ${phoneFormat}
            `;
                }
                if (websiteLink) {
                    websiteLink.href = result[0].locationWebsiteUrl;
                }

            })
            .catch(async (err) => {
                stopLoader();
                if (typeof err?.then === 'function') {
                    err = await err;
                    }
                    
                    let message = err?.response?.data?.message;
                    if(!message){
                        message = err?.message;
                    } 
                    if(!message){
                        message = '';
                    }
                   
                if (message.toLowerCase() === "full address is needed to narrow down results") {
                    const stateHandler = new StateHandler();
                    stateHandler.getStateFun();
                    const step1 = document.querySelector('.dynamic-step-1') as HTMLElement;
                    const step2 = document.querySelector('.dynamic-step-2') as HTMLElement;

                    if (step1) {
                        step1.classList.add('hidden');
                    }

                    if (step2) {
                        step2.classList.remove('hidden');
                        const closeLocalModal = document.querySelector('.close-modal-btn');
                        closeLocalModal?.addEventListener('click', function handleClick(event) {

                            step2.classList.add("hidden");
                            step1.classList.remove("hidden");
                        })
                    }
                    const modalZipCode = document.querySelector('.dynamic-step-2 #dynamic-modal-zipcode') as HTMLInputElement;
                    modalZipCode.value = encodeURIComponent(zipCode);

                    const locateAddressBumper = new FindUsAddressBumper();
                }
                else {
                    this.handleErrorScenario(zipCode);
                }
            });
    }

    handleNoResults() {
        const zipCode = this.zipInput?.value.trim();
        if (zipCode) this.handleNearbyLocationsFlow(zipCode);
        stopLoader();
    }

    private handleNearbyLocationsFlow(inputArg: any) {
        let franchiseLimit: number, units: string, nearbyLocations;
        let flag = true;
        if (flag) {
            units = "50miles";
            franchiseLimit = 50;
            this.callNearbyLocations(units, franchiseLimit, inputArg);
        }
        else {
            this.handleErrorScenario(inputArg);
        }

    }

    private handleErrorScenario(zipCode: string) {
        const step1Text1 = document.getElementById("dynamic-step1-text1") as HTMLElement;
        const step1Text2 = document.getElementById("dynamic-step1-text2") as HTMLElement;

        // Hide step1-text1
        if (step1Text1) step1Text1.style.display = "none";

        // Show step1-text2
        if (step1Text2) step1Text2.style.display = "block";

    }

    validateForm(): boolean {
        const zipCodeInput = document.getElementById("dynamic-local-search-modal") as HTMLInputElement;
        const fieldError = document.querySelector('.dynamic-find-local-modal .error-msg') as HTMLElement;

        if (!zipCodeInput || !fieldError) return false; // Ensure elements exist

        const zipCode = zipCodeInput.value.trim();

        // Reset error visibility
        fieldError.classList.add("hidden");
        zipCodeInput.classList.remove("invalid-field");

        // Check if ZIP code is required and empty
        if (zipCodeInput.required && !zipCode) {
            fieldError.classList.remove("hidden");
            zipCodeInput.classList.add("invalid-field");
            zipCodeInput.focus();
            return false;
        }

        // Validate ZIP code format
        if (!REGEX.sendZip.test(zipCode)) {
            fieldError.classList.remove("hidden");
            zipCodeInput.classList.add("invalid-field");
            zipCodeInput.focus();
            return false;
        }

        return true;
    }
}


document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.section-50-50');
    const dbaName: string | null = localStorage.getItem('dbaName');
    const webId: string | null = localStorage.getItem('weblocationId');
    //find-a-loc-wrapper to be hidden in local and localised header scenario if it has finus local modal configured
    sections?.forEach(section => {
        if (!section) return;
        const findLocLink = section.querySelector('.find-loc-link') as HTMLElement;
        const findLocWrapper = section.querySelector('.find-a-loc-wrapper') as HTMLElement;
        if ((findLocLink && webId && dbaName && !window.location.href.includes(dbaName)) || (findLocLink && webId && dbaName && window.location.href.includes(dbaName))) {
            if (findLocWrapper instanceof HTMLElement) {
                // Hide the find-a-loc-wrapper which has link
                findLocWrapper.style.display = 'none';
            }
        } else if (findLocLink) {
            FindUsModal.getInstance();
        }
    });
});